import React from "react";
import { Box, Card, CardContent, Divider, Grid, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { useStyles } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

type Props = {
  vehicleDetails: any;
  vehiclePaymentsDetails: any;
  indexContainerDetails: any;
  terminalType?: number;
};

export default function GateOutDetails({
  vehicleDetails,
  vehiclePaymentsDetails,
  indexContainerDetails,
  terminalType,
}: Props): React.ReactElement {
  const classes = useStyles();

  function truncateString(str: string, maxLength = 22) {
    if (str.length > maxLength) {
      return `${str.slice(0, maxLength)}...`;
    }
    return str;
  }

  const showVehicleDetails =
    vehicleDetails?.vehicleList && Object.keys(vehicleDetails.vehicleList).length > 0;

  const showContainerDetails =
    vehiclePaymentsDetails?.containerList && vehiclePaymentsDetails.containerList.length > 0;

  const showIndexContainerDetails =
    terminalType !== 4 && indexContainerDetails && Object.keys(indexContainerDetails).length > 0;
  return (
    <Grid container spacing={4}>
      {showVehicleDetails && (
        <Grid item xs={6}>
          <Card className="p-4 border shadow-md">
            <CardContent>
              <Typography className={classes.subDetails}>Vehicle Details</Typography>
              <Divider />
              <Grid
                container
                direction="row"
                style={{ maxHeight: 80, minHeight: 80, overflow: "auto" }}
              >
                <Grid item md={6} xs={12}>
                  <Box display="flex">
                    <Typography className={classes.subDetails}>Vehicle #:</Typography>
                    <Typography variant="body2" className={classes.rightSubHeadings}>
                      {vehicleDetails?.vehicleList && vehicleDetails?.vehicleList.vehicleNumber
                        ? vehicleDetails?.vehicleList.vehicleNumber
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item md={6} xs={12}>
                  <Box display="flex">
                    <Typography className={classes.subDetails}>Type:</Typography>
                    <Typography variant="body2" className={classes.rightSubHeadings}>
                      {vehicleDetails?.vehicleList && vehicleDetails?.vehicleList.vehicleType
                        ? vehicleDetails?.vehicleList.vehicleType
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item md={6} xs={12}>
                  <Box display="flex">
                    <Typography className={classes.subDetails}>Consignment:</Typography>
                    <Typography variant="body2" className={classes.rightSubHeadings}>
                      {vehicleDetails?.vehicleList && vehicleDetails?.vehicleList.consignmentType
                        ? vehicleDetails?.vehicleList.consignmentType
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item md={6} xs={12}>
                  <Box display="flex">
                    <Typography className={classes.subDetails}>Entry Date:</Typography>
                    <Typography variant="body2" className={classes.rightSubHeadings}>
                      {" "}
                      {vehicleDetails?.vehicleList && vehicleDetails?.vehicleList.gateEntryDate
                        ? moment(vehicleDetails?.vehicleList.gateEntryDate).format(
                            "DD-MM-YYYY hh:mm a"
                          )
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      )}
      {/* {terminalType !== 4 && (
        <Grid item xs={6}>
          <Card className="p-4 border shadow-md">
            <CardContent>
              <Typography className={classes.subDetails}> Document Details</Typography>
              <Divider />
              <Box sx={{ maxHeight: 80, minHeight: 80, overflow: "auto" }}>
                {vehiclePaymentsDetails?.documentDetails &&
                  vehiclePaymentsDetails?.documentDetails
                    ?.sort((a: any, b: any) => (a.status === b.status ? 0 : a.status ? -1 : 1))
                    ?.map((data: any, index: number) => (
                      <>
                        <Grid key={index} container direction="row">
                          <Grid item md={6} xs={12}>
                            <Box display="flex">
                              <Typography className={classes.subDetails}>Type:</Typography>
                              <Typography variant="body2" className={classes.rightSubHeadings}>
                                {data?.type && data?.type ? data?.type : "-"}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Box display="flex">
                              <Typography className={classes.subDetails}>Status:</Typography>
                              <Typography variant="body2" className={classes.rightSubHeadings}>
                                {data?.status && data?.status ? (
                                  <DoneIcon fontSize="medium" color="success" />
                                ) : (
                                  <CloseIcon fontSize="medium" color="error" />
                                )}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                        {index != vehiclePaymentsDetails?.paymentDetails?.length - 1 && <Divider />}{" "}
                      </>
                    ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )} */}

      {showContainerDetails && (
        <Grid item xs={6}>
          <Card className="p-4 border shadow-md">
            <CardContent>
              <Typography className={classes.subDetails}> Container Details</Typography>
              <Divider />

              <Box sx={{ maxHeight: 200, overflow: "auto" }}>
                {vehiclePaymentsDetails?.containerList &&
                  vehiclePaymentsDetails?.containerList?.map((data: any, index: number) => (
                    <>
                      <Grid key={index} container direction="row">
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Contaner #:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.containerNumber && data?.containerNumber
                                ? data?.containerNumber
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Vehicle #:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.vehicleRegNumber && data?.vehicleRegNumber
                                ? data?.vehicleRegNumber
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Cargo:</Typography>
                            <Tooltip title={data.cargoTypeName} arrow>
                              <Typography variant="body2" className={classes.rightSubHeadings}>
                                {data?.cargoTypeName ? truncateString(data.cargoTypeName) : "-"}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Container Size:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.containerSize && data?.containerSize !== 0
                                ? `${data.containerSize} Feet`
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        {terminalType !== 4 && (
                          <>
                            <Grid item md={4} xs={12}>
                              <Box display="flex">
                                <Typography className={classes.subDetails}>Vessel:</Typography>
                                <Typography variant="body2" className={classes.rightSubHeadings}>
                                  {data?.vessel && data?.vessel ? data?.vessel : "-"}
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item md={4} xs={12}>
                              <Box display="flex">
                                <Typography className={classes.subDetails}>Bill #:</Typography>
                                <Typography variant="body2" className={classes.rightSubHeadings}>
                                  {data?.billNo && data?.billNo ? data?.billNo : "-"}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <Box display="flex">
                                <Typography className={classes.subDetails}>GD #:</Typography>
                                <Typography variant="body2" className={classes.rightSubHeadings}>
                                  {data?.gdNo && data?.gdNo ? data?.gdNo : "-"}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <Box display="flex">
                                <Typography className={classes.subDetails}>
                                  Container Weboc Weight:
                                </Typography>
                                <Typography variant="body2" className={classes.rightSubHeadings}>
                                  {data?.containerWebocWeight || "-"}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <Box display="flex">
                                <Typography className={classes.subDetails}>
                                  Container Weight:
                                </Typography>
                                <Typography variant="body2" className={classes.rightSubHeadings}>
                                  {data?.weight || "-"}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <Box display="flex">
                                <Typography className={classes.subDetails}>
                                  Weight Difference:
                                </Typography>
                                <Typography variant="body2" className={classes.rightSubHeadings}>
                                  {data?.containerWebocWeight != null && data?.weight != null
                                    ? data.weight - data.containerWebocWeight
                                    : "-"}
                                </Typography>
                              </Box>
                            </Grid>
                          </>
                        )}
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>VIR #:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.virNo && data?.virNo ? data?.virNo : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Entry Date:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {" "}
                              {data?.createdDateTime && data?.createdDateTime
                                ? moment(data?.createdDateTime).format("DD-MM-YYYY hh:mm a")
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Importer Name:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.importer && data?.importer ? data?.importer : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                      {index != vehiclePaymentsDetails.containerList.length - 1 && <Divider />}{" "}
                    </>
                  ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )}

      {/* {showIndexContainerDetails && (
        <Grid item xs={6}>
          <Card className="p-4 border shadow-md">
            <CardContent>
              <Typography className={classes.subDetails}>Index Container Details</Typography>
              <Divider />
              <Box sx={{ maxHeight: 200, overflow: "auto" }}>
                {indexContainerDetails !== null && (
                  <>
                    <Grid container direction="row">
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Contaner #:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.containerNumber || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Vehicle #:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.vehicleRegNumber || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Cargo:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.cargoTypeName || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Vessel:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.vessel || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Bill #:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.billNo || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>GD #:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.gdNo || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>
                            Container Weboc Weight:
                          </Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.containerGrossWeight || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Container Weight:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.weight || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Weight Difference:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.weight != null &&
                            indexContainerDetails?.containerGrossWeight != null
                              ? indexContainerDetails.weight -
                                indexContainerDetails.containerGrossWeight
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>VIR #:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {indexContainerDetails?.virNo || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Box display="flex">
                          <Typography className={classes.subDetails}>Entry Date:</Typography>
                          <Typography variant="body2" className={classes.rightSubHeadings}>
                            {" "}
                            {indexContainerDetails?.dateTime || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )} */}
      {/* {terminalType !== 4 && (
        <Grid item xs={12}>
          <Card className="p-4 border shadow-md">
            <CardContent>
              <Typography className={classes.subDetails}> Payment Details</Typography>
              <Divider />
              <Box sx={{ maxHeight: 200, overflow: "auto" }}>
                {vehiclePaymentsDetails?.paymentDetails &&
                  vehiclePaymentsDetails?.paymentDetails?.map((data: any, index: number) => (
                    <>
                      <Grid key={index} container direction="row">
                        <Grid item md={3} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Contaner #:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.containerNumber && data?.containerNumber
                                ? data?.containerNumber
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Index #:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.indexNo && data?.indexNo ? data?.indexNo : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Payment Status:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.status ? truncateString(data.status) : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Payment Method:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.paymentMethod ? truncateString(data.paymentMethod) : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Weight:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {data?.weight && data?.weight ? data?.weight : "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <Box display="flex">
                            <Typography className={classes.subDetails}>Payment Date:</Typography>
                            <Typography variant="body2" className={classes.rightSubHeadings}>
                              {" "}
                              {data?.paymentDate && data?.paymentDate
                                ? moment(data?.paymentDate).format("DD-MM-YYYY hh:mm a")
                                : "-"}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                      {index != vehiclePaymentsDetails?.paymentDetails?.length - 1 && <Divider />}{" "}
                    </>
                  ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )} */}
    </Grid>
  );
}
